import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/dmarcadvisor.webp';
import screenshot_target from '../../../images/letterfunnel/martijngroeneweg.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Martijn Groeneweg"
      firstname="Martijn"
      companyname="DMARC Advisor"
      competition="EasyDMARC en Red Sift"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/martijngroeneweg.js